import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Cell,
  Tooltip,
} from "recharts";

const chartData = [
  { label: "Lead Completed", value: 12500, percent: 100, color: "#0f5c63" },
  { label: "Form Completed", value: 9000, percent: 72, color: "#3f4da0" },
  { label: "Disbursed", value: 2750, percent: 22, color: "#57a66a" },
  { label: "Approved", value: 4750, percent: 38, color: "#5aa0b8" },
];

const tableData = [
  { stage: "Lead Generated", leads: 12500, percent: 100, drop: "-" },
  { stage: "Form Completed", leads: 9000, percent: 72, drop: 28 },
  { stage: "Approved", leads: 4750, percent: 38, drop: 34 },
  { stage: "Disbursed", leads: 2750, percent: 22, drop: 16 },
];

const DailyTrend = () => {
  return (
    <div className="daily-trend-container">
      <div className="row">
        {/* LEFT - CHART */}
        <div className="col-lg-6">
          <h3 className="common-heading">Daily Trend</h3>

          <div className="">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={chartData}
                layout="vertical"
                margin={{ top: 10, right: 20, left: 20, bottom: 10 }}
              >
                <XAxis type="number" />
                <YAxis
                  dataKey="label"
                  type="category"
                  width={100}
                  tick={{ fontSize: 13 }}
                  tickMargin={10}
                  axisLine={false}
                  tickLine={false}
                  dx={-5}
                />
                <Tooltip />

                <Bar dataKey="value" radius={[4, 4, 4, 4]}>
                  {chartData.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="table-box">
            <div className="table-header row">
              <div className="col">Stage</div>
              <div className="col">Leads</div>
              <div className="col">%</div>
              <div className="col">Drop %</div>
            </div>

            {tableData.map((row, index) => (
              <div className="table-row row" key={index}>
                <div className="col">{row.stage}</div>
                <div className="col">{row.leads.toLocaleString()}</div>
                <div className="col">{row.percent}%</div>
                <div className={`col ${row.drop !== "-" ? "drop-red" : ""}`}>
                  {row.drop === "-" ? "-" : `${row.drop}%`}
                </div>
              </div>
            ))}
          </div>

          <div className="alert-box">
            <span className="icon">!</span>
            Highest Leakage: Form Completed → Approved (34%)
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyTrend;
